// Registers <cart-upsells-component>. Loaded once per page from
// snippets/header-actions.liquid so the custom element is defined even when
// the cart drawer starts empty (the markup is rendered later via section
// morph, and morph-inserted <script> tags don't execute).
if (!customElements.get('cart-upsells-component')) {
  customElements.define(
    'cart-upsells-component',
    class extends HTMLElement {
      connectedCallback() {
        this.addEventListener('click', this.handleClick);
      }

      handleClick = async (event) => {
        const button = event.target.closest('.js-upsell-add');
        if (!button || button.disabled) return;
        event.preventDefault();

        const variantId = button.getAttribute('data-variant-id');
        if (!variantId) return;

        const originalText = button.innerText;
        button.innerText = 'Adding...';
        button.disabled = true;

        const sectionIds = Array.from(
          document.querySelectorAll('cart-items-component[data-section-id]')
        )
          .map((el) => el.dataset.sectionId)
          .filter(Boolean);

        try {
          const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',
            },
            body: JSON.stringify({
              items: [{ id: parseInt(variantId, 10), quantity: 1 }],
              sections: sectionIds.join(','),
            }),
          });

          const data = await response.json();
          if (data.status) throw new Error(data.description || data.message || 'Cart add failed');

          // Horizon's cart-items-component listens for 'cart:update' and morphs
          // the section, which refreshes the drawer (and this upsell list).
          const cartUpdate = new Event('cart:update', { bubbles: true });
          cartUpdate.detail = {
            resource: data,
            sourceId: 'cart-upsells',
            data: { source: 'cart-upsells', sections: data.sections },
          };
          document.dispatchEvent(cartUpdate);

          const drawer = document.querySelector('cart-drawer-component');
          if (drawer && typeof drawer.open === 'function' && !drawer.querySelector('dialog[open]')) {
            drawer.open();
          }

          button.innerText = 'Added!';
        } catch (error) {
          console.error('Cart upsell add failed:', error);
          button.innerText = 'Error';
        } finally {
          setTimeout(() => {
            button.innerText = originalText;
            button.disabled = false;
          }, 2000);
        }
      };
    }
  );
}
